// extracted by mini-css-extract-plugin
export default {"item":"style_item__Y9+20","contain":"style_contain__faSic","cover":"style_cover__HH5CE"};